export const androidPlayPackageId = 'ai.myvpn.app';

const DEV_CLICK_GATEWAY_URL = '/api/gateway/'
const PROD_CLICK_GATEWAY_URL = 'https://functions.yandexcloud.net/d4ek4g0qshdemu6s99ri'

/** Прямой Google Play URL без referrer. */
export const androidPlayWebUrl =
    `https://play.google.com/store/apps/details?id=${androidPlayPackageId}`;

export const config = {
    yandexMetrikaId: Number(process.env.VUE_APP_YANDEX_METRIKA_ID),
    androidAppUrl: androidPlayWebUrl,
}

export const baseUrl = process.env.VUE_APP_BASE_URL;
export const shortBaseUrl = process.env.VUE_APP_SHORT_BASE_URL;

export const getClickGatewayUrl = () => {
    if (process.env.NODE_ENV === 'production') {
        return PROD_CLICK_GATEWAY_URL
    }
    return DEV_CLICK_GATEWAY_URL
}

export const getAndroidAppUrl = (clickId) => {
    const base = config.androidAppUrl
    if (clickId == null || clickId === '') {
        return base
    }

    const url = new URL(base)
    url.searchParams.set('referrer', `clickid=${clickId}`)
    return url.toString()
}

if (process.env.NODE_ENV === 'development') {
  console.log("Running in development mode");
}

if (process.env.NODE_ENV === 'production') {
  console.log("Running in production mode");
}
